import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import Intro from "../sections/Intro/Intro";

const Contact = () => {
  return (
    <div className="column">
      <Header />
      <Intro
        primary="Contact an expert bookkeeper."
        secondary="Clear communication and tailored advice from professionals who take you seriously."
      />
      <div className="container">
        <div className="column w64 g1 center">
          <div className="columns g1">
            <a
              href="tel:+18018301084"
              className="flex between secondary"
            >
              <p className="purple">Call</p>
              <strong className="purple">801-830-1084</strong>
            </a>
            <a
              href="sms:+18018767769"
              className="flex between secondary"
            >
              <p className="purple">Text</p>
              <strong className="purple">801-876-7769</strong>
            </a>
          </div>
          <a
            className="secondary"
            href="mailto:info@crystal-clear-consulting.com"
          >
            info@crystal-clear-consulting.com
          </a>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Contact;
